import type { FC } from 'react';
import { Table } from 'reactstrap';
import { AdvancedJavaWrapper } from './AdvancedJava.styled';

interface AdvancedJavaProps {}

const AdvancedJava: FC<AdvancedJavaProps> = () => (
 <AdvancedJavaWrapper>	
   <header className="entry-header">
      <h1 className="entry-title" itemProp="headline">Advance Java</h1>			
   </header>
   <div className="entry-content clear" itemProp="text"  style={{height: 'auto !important'}}>
      <p className="text-align-justify">Advance Java<em>&nbsp;or&nbsp;</em>J2EE (Java Enterprise Edition) is a platform Independent, Java Centric environment. In other words, to develop, build &amp; deploy Web-based applications online, advance java is useful. </p>
      <br />
      <Table bordered striped className="text-align-justify">
         <thead>
            <tr>
               <th className="text-align-center"><strong>Core Java</strong></th>
               <th className="text-align-center"><strong>J2EE (Advance Java)</strong></th>
            </tr>
         </thead>
         <tbody>
            <tr>
               <td>Also known as Java Standard Edition.</td>
               <td>Also known as Java Enterprise Edition.</td>
            </tr>
            <tr>
               <td>To develop a general-purpose application, it can be used.</td>
               <td>To develop online applications and mobile applications, it can be used.</td>
            </tr>
            <tr>
               <td>Only one tier architecture is used by core java. Therefore it is called a ‘stand-alone’ application.</td>
               <td>The two-tier architecture is used by advanced java. In other words, client-side architecture &amp; server-side (backend) architecture.</td>
            </tr>
            <tr>
               <td>Core java is derived from C, C++</td>
               <td>J2EE is an extension of Java SE.</td>
            </tr>
            <tr>
               <td>Core java includes features like OOPS, data type, exception handling, etc.</td>
               <td>Advance java includes features like the Collection of Java APIs. For Instance Servlet, JSP, etc. </td>
            </tr>
         </tbody>
      </Table>
      <br />
      <p className="text-align-justify">In this section, the below-mentioned topics will be covered:</p>
      <ul className="text-align-justify">
         <li>Synchronization</li>
         <li>JDBC</li>
         <li>Serialization &amp; Deserialization</li>
         <li>Servlets</li>
         <li>JSP</li>
         <li>Try with resources</li>
      </ul>
   </div>
 </AdvancedJavaWrapper>
);

export default AdvancedJava;
